import * as actions from './actions';
import { LoadingAction } from '../common/loading-action';
import { ErrorAction } from '../common/error-action';
import { ConnectedAccount } from '@services/stripe-connect/types/connected-account';
import { CreateAccountInput } from '@services/stripe-connect/platform/create-account';
import Dinero from 'dinero.js';

export class GetConnectedAccount implements LoadingAction {
  readonly type = actions.GET_CONNECTED_ACCOUNT;
  readonly isLoading = true;
  readonly mainLoader = true;
}

export class GetConnectedAccountSuccess implements LoadingAction {
  readonly type = actions.GET_CONNECTED_ACCOUNT_SUCCESS;
  readonly isLoading = false;

  constructor(public account: ConnectedAccount) {}
}

export class GetConnectedAccountError implements ErrorAction {
  readonly type = actions.GET_CONNECTED_ACCOUNT_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class CreateConnectedAccount implements LoadingAction {
  readonly type = actions.CREATE_CONNECTED_ACCOUNT;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public data: CreateAccountInput) {}
}

export class CreateConnectedAccountSuccess implements LoadingAction {
  readonly type = actions.CREATE_CONNECTED_ACCOUNT_SUCCESS;
  readonly isLoading = false;

  constructor(public account: ConnectedAccount) {}
}

export class CreateConnectedAccountError implements ErrorAction {
  readonly type = actions.CREATE_CONNECTED_ACCOUNT_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class CreateOnboardingLink implements LoadingAction {
  readonly type = actions.CREATE_ONBOARDING_LINK;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public accountId: string) {}
}

export class CreateOnboardingLinkSuccess implements LoadingAction {
  readonly type = actions.CREATE_ONBOARDING_LINK_SUCCESS;
  readonly isLoading = false;

  constructor(public accountId: string) {}
}

export class CreateOnboardingLinkError implements ErrorAction {
  readonly type = actions.CREATE_ONBOARDING_LINK_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class CreateLoginLink implements LoadingAction {
  readonly type = actions.CREATE_LOGIN_LINK;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public accountId: string) {}
}

export class CreateLoginLinkSuccess implements LoadingAction {
  readonly type = actions.CREATE_LOGIN_LINK_SUCCESS;
  readonly isLoading = false;

  constructor(public accountId: string) {}
}

export class CreateLoginLinkError implements ErrorAction {
  readonly type = actions.CREATE_LOGIN_LINK_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class CreateTransfer implements LoadingAction {
  readonly type = actions.CREATE_TRANSFER;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public amount: Dinero.Dinero) {}
}

export class CreateTransferSuccess implements LoadingAction {
  readonly type = actions.CREATE_TRANSFER_SUCCESS;
  readonly isLoading = false;
}

export class CreateTransferError implements ErrorAction {
  readonly type = actions.CREATE_TRANSFER_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export type StripeConnectActions =
  | GetConnectedAccount
  | GetConnectedAccountSuccess
  | GetConnectedAccountError
  | CreateConnectedAccount
  | CreateConnectedAccountSuccess
  | CreateConnectedAccountError
  | CreateOnboardingLink
  | CreateOnboardingLinkSuccess
  | CreateOnboardingLinkError
  | CreateLoginLink
  | CreateLoginLinkSuccess
  | CreateLoginLinkError
  | CreateTransfer
  | CreateTransferSuccess
  | CreateTransferError;
